import React from 'react';
import { withRouter } from 'react-router-dom';

import {makeStyles} from "@material-ui/core";
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(() => ({
  middleSchoolButton: {
    width: '135px',
    margin: '0px 5px',
    color: 'white !important',
    fontSize: '20px',
    backgroundColor: '#99d6ce',
    border: '1px solid black',
    '&:hover': {
      backgroundColor: 'white !important',
      color: '#99d6ce !important',
      border: '1px solid #99d6ce'
    }
  },
}));
const MiddleSchoolButton = ({ history }) => {
  const classes = useStyles();
  return (
    <div>
      <Button className={classes.middleSchoolButton} onClick={() => history.push('/home/3')}>6  - 8</Button>
    </div>
  );
};

export default withRouter(MiddleSchoolButton);
